const f = (name, label, type = "text", extra = {}) => ({
  name, label, type, ...extra,
});

const common = {
  status: f("status", "Status", "select", {
    options: [
      { value: "active", label: "Aktif" },
      { value: "inactive", label: "Nonaktif" },
    ],
  }),
};

const schemas = {
  "profil-perusahaan": {
    fields: [
      f("name", "Nama Perusahaan", "text", { required: true }),
      f("legal_name", "Nama Legal"),
      f("tax_number", "NPWP"),
      f("email", "Email", "email"),
      f("phone", "Telepon"),
      f("address", "Alamat", "textarea"),
    ],
  },
  "master-lokasi": {
    fields: [
      f("code", "Kode Lokasi", "text", { required: true }),
      f("name", "Nama Lokasi", "text", { required: true }),
      f("location_type", "Jenis Lokasi", "select", {
        options: ["Gudang", "Outlet", "Kantor", "Lainnya"].map(x => ({ value: x, label: x })),
      }),
      f("address", "Alamat", "textarea"),
      f("city", "Kota"),
      f("province", "Provinsi"),
      f("status", "Status", "select", { options: [{value:"active",label:"Aktif"},{value:"inactive",label:"Nonaktif"}] }),
    ],
  },
  "semua-item": {
    fields: [
      f("sku", "SKU", "text", { required: true }),
      f("name", "Nama Item", "text", { required: true }),
      f("item_type", "Jenis Item", "select", {
        options: ["Barang Dagangan", "Perlengkapan", "Peralatan", "Jasa"].map(x => ({value:x,label:x})),
      }),
      f("category", "Kategori"),
      f("unit", "Satuan"),
      f("purchase_price", "Harga Beli", "number"),
      f("sales_price", "Harga Jual", "number"),
      common.status,
    ],
  },
  "barang-dagangan": {
    fields: [
      f("sku", "SKU", "text", { required: true }),
      f("name", "Nama Barang", "text", { required: true }),
      f("category", "Kategori"),
      f("brand", "Merek"),
      f("unit", "Satuan"),
      f("purchase_price", "Harga Beli", "number"),
      f("sales_price", "Harga Jual", "number"),
      f("track_stock", "Kelola Stok", "checkbox"),
      common.status,
    ],
  },
  "perlengkapan": {
    fields: [f("code","Kode"),f("name","Nama Perlengkapan","text",{required:true}),f("category","Kategori"),f("unit","Satuan"),f("purchase_price","Harga Beli","number"),common.status],
  },
  "peralatan": {
    fields: [f("code","Kode"),f("name","Nama Peralatan","text",{required:true}),f("category","Kategori"),f("asset_number","Nomor Aset"),f("purchase_price","Harga Beli","number"),common.status],
  },
  "jasa": {
    fields: [f("code","Kode Jasa"),f("name","Nama Jasa","text",{required:true}),f("category","Kategori"),f("unit","Satuan"),f("sales_price","Harga Jual","number"),common.status],
  },
  "kategori-item": {
    fields: [f("code","Kode Kategori"),f("name","Nama Kategori","text",{required:true}),f("parent","Kategori Induk"),f("description","Deskripsi","textarea"),common.status],
  },
  "merek": {
    fields: [f("code","Kode Merek"),f("name","Nama Merek","text",{required:true}),f("description","Deskripsi","textarea"),common.status],
  },
  "satuan": {
    fields: [f("code","Kode Satuan","text",{required:true}),f("name","Nama Satuan","text",{required:true}),f("symbol","Simbol"),f("description","Deskripsi"),common.status],
  },
  "konversi-satuan": {
    fields: [f("from_unit","Satuan Asal","text",{required:true}),f("to_unit","Satuan Tujuan","text",{required:true}),f("ratio","Rasio Konversi","number",{required:true}),f("description","Keterangan")],
  },
  "varian": {
    fields: [f("code","Kode Varian"),f("name","Nama Varian","text",{required:true}),f("attribute","Atribut"),f("value","Nilai"),common.status],
  },
  "modifier": {
    fields: [f("code","Kode Modifier"),f("name","Nama Modifier","text",{required:true}),f("selection_type","Tipe Pilihan","select",{options:[{value:"single",label:"Single"},{value:"multiple",label:"Multiple"}]}),f("min_selection","Minimum Pilihan","number"),f("max_selection","Maksimum Pilihan","number"),common.status],
  },
  "resep-dan-bom": {
    fields: [f("code","Kode Resep/BOM"),f("name","Nama Resep/BOM","text",{required:true}),f("output_item","Item Hasil"),f("output_qty","Kuantitas Hasil","number"),f("component","Komponen"),f("component_qty","Kuantitas Komponen","number"),common.status],
  },
  "kategori-supplier": {
    fields: [f("code","Kode Kategori"),f("name","Nama Kategori","text",{required:true}),f("description","Deskripsi","textarea"),common.status],
  },
  "kontak-supplier": {
    fields: [f("code","Kode Supplier"),f("name","Nama Supplier","text",{required:true}),f("contact_person","Nama Kontak"),f("email","Email","email"),f("phone","Telepon"),f("tax_number","NPWP"),common.status],
  },
  "alamat-supplier": {
    fields: [f("supplier","Supplier","text",{required:true}),f("address_type","Jenis Alamat"),f("address","Alamat","textarea"),f("city","Kota"),f("province","Provinsi"),f("postal_code","Kode Pos")],
  },
  "rekening-supplier": {
    fields: [f("supplier","Supplier","text",{required:true}),f("bank","Nama Bank"),f("account_number","Nomor Rekening"),f("account_name","Nama Pemilik Rekening"),common.status],
  },
  "harga-supplier": {
    fields: [f("supplier","Supplier","text",{required:true}),f("item","Item","text",{required:true}),f("unit","Satuan"),f("price","Harga","number"),f("valid_from","Berlaku Mulai","date"),f("valid_until","Berlaku Sampai","date")],
  },
  "syarat-pembayaran-supplier": {
    fields: [f("code","Kode Termin"),f("name","Nama Termin","text",{required:true}),f("days","Jatuh Tempo (Hari)","number"),f("description","Keterangan"),common.status],
  },
  "kategori-pelanggan-master": {
    fields: [f("code","Kode Kategori"),f("name","Nama Kategori","text",{required:true}),f("description","Deskripsi","textarea"),common.status],
  },
  "kontak-pelanggan": {
    fields: [f("code","Kode Pelanggan"),f("name","Nama Pelanggan","text",{required:true}),f("contact_person","Nama Kontak"),f("email","Email","email"),f("phone","Telepon"),common.status],
  },
  "alamat-pelanggan": {
    fields: [f("customer","Pelanggan","text",{required:true}),f("address_type","Jenis Alamat"),f("address","Alamat","textarea"),f("city","Kota"),f("province","Provinsi"),f("postal_code","Kode Pos")],
  },
  "daftar-harga-pelanggan": {
    fields: [f("code","Kode Daftar Harga"),f("name","Nama Daftar Harga","text",{required:true}),f("customer_category","Kategori Pelanggan"),f("item","Item"),f("price","Harga","number"),f("valid_from","Berlaku Mulai","date"),f("valid_until","Berlaku Sampai","date"),common.status],
  },
  "syarat-pembayaran-pelanggan": {
    fields: [f("code","Kode Termin"),f("name","Nama Termin","text",{required:true}),f("days","Jatuh Tempo (Hari)","number"),f("description","Keterangan"),common.status],
  },
  "kategori-akun": {
    fields: [f("code","Kode Kategori"),f("name","Nama Kategori","text",{required:true}),f("account_type","Tipe Akun"),f("normal_balance","Saldo Normal"),common.status],
  },
  "kas": {
    fields: [f("code","Kode Kas"),f("name","Nama Kas","text",{required:true}),f("currency","Mata Uang"),f("account","Akun GL"),common.status],
  },
  "rekening-bank": {
    fields: [f("code","Kode Bank"),f("name","Nama Rekening","text",{required:true}),f("bank","Nama Bank"),f("account_number","Nomor Rekening"),f("account_name","Pemilik Rekening"),f("currency","Mata Uang"),common.status],
  },
  "metode-pembayaran": {
    fields: [f("code","Kode Metode"),f("name","Nama Metode","text",{required:true}),f("payment_type","Jenis Pembayaran"),f("account","Akun GL"),common.status],
  },
  "kategori-pendapatan": {
    fields: [f("code","Kode Kategori"),f("name","Nama Kategori","text",{required:true}),f("account","Akun GL"),f("description","Deskripsi"),common.status],
  },
  "kategori-beban": {
    fields: [f("code","Kode Kategori"),f("name","Nama Kategori","text",{required:true}),f("account","Akun GL"),f("description","Deskripsi"),common.status],
  },
  "pajak": {
    fields: [f("code","Kode Pajak"),f("name","Nama Pajak","text",{required:true}),f("rate","Tarif (%)","number"),f("tax_type","Jenis Pajak"),f("account","Akun GL"),common.status],
  },
  "dimensi-akuntansi": {
    fields: [f("code","Kode Dimensi"),f("name","Nama Dimensi","text",{required:true}),f("dimension_type","Jenis Dimensi"),f("description","Deskripsi"),common.status],
  },
  "periode-akuntansi": {
    fields: [f("code","Kode Periode"),f("name","Nama Periode","text",{required:true}),f("start_date","Tanggal Mulai","date"),f("end_date","Tanggal Akhir","date"),f("period_status","Status Periode","select",{options:[{value:"open",label:"Terbuka"},{value:"closed",label:"Ditutup"}]})],
  },
  "status-kepegawaian": {
    fields: [f("code","Kode Status"),f("name","Nama Status","text",{required:true}),f("description","Deskripsi"),common.status],
  },
  "komponen-gaji": {
    fields: [f("code","Kode Komponen"),f("name","Nama Komponen","text",{required:true}),f("calculation_type","Metode Hitung"),f("amount","Nominal","number"),f("taxable","Kena Pajak","checkbox"),common.status],
  },
  "komponen-potongan": {
    fields: [f("code","Kode Potongan"),f("name","Nama Potongan","text",{required:true}),f("calculation_type","Metode Hitung"),f("amount","Nominal","number"),common.status],
  },
  "jenis-cuti": {
    fields: [f("code","Kode Cuti"),f("name","Nama Cuti","text",{required:true}),f("quota","Kuota Hari","number"),f("paid","Dibayar","checkbox"),common.status],
  },
  "jenis-lembur": {
    fields: [f("code","Kode Lembur"),f("name","Nama Lembur","text",{required:true}),f("multiplier","Pengali Upah","number"),f("description","Keterangan"),common.status],
  },
  "pola-jadwal": {
    fields: [f("code","Kode Jadwal"),f("name","Nama Jadwal","text",{required:true}),f("start_time","Jam Mulai","text"),f("end_time","Jam Selesai","text"),f("break_minutes","Istirahat (Menit)","number"),common.status],
  },
  "template-kpi": {
    fields: [f("code","Kode KPI"),f("name","Nama KPI","text",{required:true}),f("metric","Indikator"),f("target","Target","number"),f("weight","Bobot (%)","number"),common.status],
  },
  "master-aset": {
    fields: [f("asset_code","Kode Aset","text",{required:true}),f("name","Nama Aset","text",{required:true}),f("category","Kategori Aset"),f("location","Lokasi Aset"),f("purchase_date","Tanggal Pembelian","date"),f("purchase_cost","Nilai Perolehan","number"),common.status],
  },
  "kategori-aset-master": {
    fields: [f("code","Kode Kategori"),f("name","Nama Kategori","text",{required:true}),f("depreciation_method","Metode Penyusutan"),f("useful_life","Umur Manfaat (Bulan)","number"),common.status],
  },
  "lokasi-aset-master": {
    fields: [f("code","Kode Lokasi"),f("name","Nama Lokasi","text",{required:true}),f("address","Alamat","textarea"),f("responsible_person","Penanggung Jawab"),common.status],
  },
  "metode-penyusutan": {
    fields: [f("code","Kode Metode"),f("name","Nama Metode","text",{required:true}),f("method","Metode"),f("description","Deskripsi"),common.status],
  },
  "kategori-pemeliharaan": {
    fields: [f("code","Kode Kategori"),f("name","Nama Kategori","text",{required:true}),f("description","Deskripsi"),common.status],
  },
  "jenis-insiden": {
    fields: [f("code","Kode Insiden"),f("name","Nama Insiden","text",{required:true}),f("severity","Tingkat Keparahan"),f("description","Deskripsi"),common.status],
  },
  "checklist-operasional": {
    fields: [f("code","Kode Checklist"),f("name","Nama Checklist","text",{required:true}),f("area","Area Operasional"),f("frequency","Frekuensi"),f("description","Deskripsi","textarea"),common.status],
  },
  "kategori-promosi": {
    fields: [f("code","Kode Kategori"),f("name","Nama Kategori","text",{required:true}),f("description","Deskripsi"),common.status],
  },
  "campaign": {
    fields: [f("code","Kode Campaign"),f("name","Nama Campaign","text",{required:true}),f("start_date","Tanggal Mulai","date"),f("end_date","Tanggal Selesai","date"),f("budget","Budget","number"),common.status],
  },
  "poin-reward": {
    fields: [f("code","Kode Program"),f("name","Nama Program","text",{required:true}),f("earn_rate","Rasio Perolehan Poin","number"),f("expiry_days","Masa Berlaku (Hari)","number"),common.status],
  },
  "reward": {
    fields: [f("code","Kode Reward"),f("name","Nama Reward","text",{required:true}),f("points_required","Poin Dibutuhkan","number"),f("stock","Stok","number"),common.status],
  },
  "kanal-penjualan": {
    fields: [f("code","Kode Kanal"),f("name","Nama Kanal","text",{required:true}),f("channel_type","Jenis Kanal"),f("description","Deskripsi"),common.status],
  },
  "segmentasi-pelanggan-master": {
    fields: [f("code","Kode Segment"),f("name","Nama Segment","text",{required:true}),f("criteria","Kriteria","textarea"),common.status],
  },
  "daftar-pengguna": {
    fields: [f("username","Username","text",{required:true}),f("name","Nama Pengguna","text",{required:true}),f("email","Email","email"),f("role","Role"),f("outlet_scope","Scope Outlet"),common.status],
  },
  "referensi-role": {
    fields: [f("code","Kode Role"),f("name","Nama Role","text",{required:true}),f("description","Deskripsi","textarea"),common.status],
  },
  "referensi-permission": {
    fields: [f("code","Kode Permission"),f("name","Nama Permission","text",{required:true}),f("module","Modul"),f("action","Aksi"),f("description","Deskripsi"),common.status],
  },
  "grup-akses": {
    fields: [f("code","Kode Grup"),f("name","Nama Grup","text",{required:true}),f("description","Deskripsi"),common.status],
  },
  "scope-akses": {
    fields: [f("code","Kode Scope"),f("name","Nama Scope","text",{required:true}),f("scope_type","Jenis Scope"),f("description","Deskripsi"),common.status],
  },
  "penomoran-dokumen": {
    fields: [f("document_type","Jenis Dokumen","text",{required:true}),f("prefix","Prefix"),f("number_format","Format Nomor"),f("next_number","Nomor Berikutnya","number"),f("reset_period","Reset Periode"),common.status],
  },
  "template-dokumen": {
    fields: [f("code","Kode Template"),f("name","Nama Template","text",{required:true}),f("document_type","Jenis Dokumen"),f("description","Deskripsi","textarea"),common.status],
  },
  "mata-uang": {
    fields: [f("code","Kode Mata Uang","text",{required:true}),f("name","Nama Mata Uang","text",{required:true}),f("symbol","Simbol"),f("decimal_places","Digit Desimal","number"),common.status],
  },
  "zona-waktu": {
    fields: [f("code","Kode Zona"),f("name","Nama Zona","text",{required:true}),f("utc_offset","UTC Offset"),f("description","Deskripsi"),common.status],
  },
  "preferensi-perusahaan": {
    fields: [f("key","Key Preferensi","text",{required:true}),f("value","Nilai Preferensi","text",{required:true}),f("category","Kategori"),f("description","Deskripsi"),common.status],
  },
  "referensi-integrasi": {
    fields: [f("code","Kode Integrasi"),f("name","Nama Integrasi","text",{required:true}),f("provider","Provider"),f("endpoint","Endpoint"),f("description","Deskripsi","textarea"),common.status],
  },
};

export const getMasterSchema = (slug, title = "") => {
  const schema = schemas[slug];
  if (schema) return { slug, title, ...schema };

  return {
    slug,
    title,
    fields: [
      f("code", "Kode", "text", { required: true }),
      f("name", "Nama", "text", { required: true }),
      f("description", "Deskripsi", "textarea"),
      common.status,
    ],
  };
};

export default schemas;
